import { GAME_MOVED, SET_GAMES_WITH_NEW_MOVES } from './constants';
import { LOGIN_SUCCESS } from '../Login/constants';

/**
 * How many of your games have moves you haven't seen (the server's SeenMoves), for the menu's dot. It comes with
 * the signed-in user, and each move and each "seen" answer brings the new count.
 */
function reducer(state = 0, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return action.payload.getIn(['user', 'games_with_new_moves']) || 0;
    case GAME_MOVED:
      return action.payload.gamesWithNewMoves;
    case SET_GAMES_WITH_NEW_MOVES:
      return action.payload;
    default:
      return state;
  }
}

export default reducer;

export const selectGamesWithNewMoves = (state) => state.newMoves;
